<dt-modal-content size="small" (closeClick)="close()">
  <ng-template #title i18n>Anmelden</ng-template>
  <ng-template #content>
    @if (data?.showSaveHint) {
      <div class="hint">
        <mat-icon>info</mat-icon>
        <div i18n>Bitte melde Dich zum Speichern an</div>
      </div>
    }
    <form #actualForm="ngForm" class="dt-form" (ngSubmit)="onSubmit()" [formGroup]="loginForm">
      <mat-form-field>
        <mat-label i18n>E-Mail-Adresse</mat-label>
        <input type="email" matInput formControlName="email" />
        @if (shouldShowSeedUsers) {
          <button
            mat-icon-button
            matSuffix
            color="accent"
            [matMenuTriggerFor]="seedUserMenu"
            (click)="$event.stopPropagation()"
            type="button"
            ><mat-icon>recent_actors</mat-icon></button
          >
        }
        <mat-menu #seedUserMenu>
          @for (seedUser of seedUsers; track seedUser) {
            <button mat-menu-item (click)="loginWithSeedUser(seedUser)">
              {{ seedUser.name }}
            </button>
          }
        </mat-menu>
      </mat-form-field>

      <mat-form-field>
        <mat-label i18n>Passwort</mat-label>
        <input type="password" matInput formControlName="password" />
      </mat-form-field>

      @if (loginForm.getError('server-error') === 'rate-limit') {
        <mat-error i18n>Du kannst in kurzer Zeit zu viele Anfragen gestellt. Bitte versuche es später noch einmal.</mat-error>
      }

      @if (loginForm.getError('server-error') === 'credentials') {
        <mat-error i18n>Die eingegebene Kombination aus E-Mail und Passwort ist falsch.</mat-error>
      }

      @if (loginForm.getError('server-error') === 'something') {
        <mat-error i18n>Bei der Übertragung der Daten ist ein Fehler aufgetreten.</mat-error>
      }

      <button
        mat-raised-button
        [dtOverlayProgress]="loginForm.disabled"
        type="submit"
        color="accent"
        [disabled]="(!loginForm.valid && !actualForm.submitted) || loginForm.disabled"
        i18n
        >Anmelden</button
      >
    </form>

    <div class="other-options"
      ><a (click)="openRegisterModal()" i18n>Account erstellen</a>&nbsp;·&nbsp;<a (click)="openPasswordResetModal()" i18n
        >Passwort vergessen</a
      ></div
    >
  </ng-template>
</dt-modal-content>
